document.addEventListener("DOMContentLoaded", function() {
    function loadThermometer() {
        let thermometerElementC = document.getElementById("thermometer-c");
        let thermometerElementF = document.getElementById("thermometer-f");
        const animation = lottie.loadAnimation({
            container: thermometerElementC,
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: thermometerElementC.dataset.src
        });

        const animation2 = lottie.loadAnimation({
            container: thermometerElementF,
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: thermometerElementF.dataset.src
        });


        animation.addEventListener('DOMLoaded', () => {
            let currentStep = 0;
            const totalFrames = animation.getDuration(true);
            const frameRate = animation.frameRate;

            //const duration = animation.getDuration(true) /  animation.frameRate; // duration in seconds
            const exploreElement = document.querySelector('.explore');
            document.getElementById('toggleTemp').addEventListener('click', () => {
                exploreElement.classList.add('hidden');
                let currentFrame = currentStep * frameRate;
                currentStep++;

                let targetFrame = currentStep * frameRate;
                if (targetFrame > totalFrames) {
                    targetFrame = frameRate;
                    currentStep = 1;
                    currentFrame = 0;
                }
                animation.playSegments([currentFrame, targetFrame], true);
                animation2.playSegments([currentFrame, targetFrame], true);
                showThermometerTabs(currentStep);

            });

            document.getElementById('unit-switch').addEventListener('change', function() {
                const isChecked = this.querySelector('input').checked;
                const currentUnit = isChecked ? 'C' : 'F';
                thermometerElementC.classList.toggle('hidden');
                thermometerElementF.classList.toggle('hidden');
                document.querySelectorAll('.step').forEach(step => {
                    const showCelsius = currentUnit === 'C';
                    step.querySelector('.fahrenheit').classList.toggle('hidden', showCelsius);
                    step.querySelector('.celcius').classList.toggle('hidden', !showCelsius);

                });
            });
        });


    }


    function showThermometerTabs(currentStep) {
        let steps = document.querySelectorAll('.step');
        steps.forEach(step => {
            if (parseInt(step.dataset.id) === currentStep) {
                step.classList.remove('hidden');
            } else {
                step.classList.add('hidden');
            }
        });

        let progress = document.querySelector('.steps');
        let total = steps.length;
        if (currentStep === total) {
            steps[0].classList.remove('hidden');
        }
        let percent = (currentStep / (total - 1)) * 100;

        if (currentStep === steps.length) {
            percent = 0;
        }
        progress.style.setProperty('--percent', percent + '%');
    }

    if (document.getElementById("thermometer-c")) {
        loadThermometer();
    }
});
